import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 13.5 12.376"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.5 6.188a.564.564 0 0 1-.562.563H6.75a.56.56 0 1 1 0-1.125h6.188a.56.56 0 0 1 .562.562M6.75 2.251h6.188a.562.562 0 1 0 0-1.125H6.75a.56.56 0 0 0-.397.165.56.56 0 0 0 0 .795.56.56 0 0 0 .397.165m6.188 7.875H6.75a.56.56 0 0 0-.397.165.56.56 0 0 0 0 .795.56.56 0 0 0 .397.165h6.188a.562.562 0 1 0 0-1.125M3.54.165 1.688 2.018.961 1.29a.566.566 0 0 0-.796 0 .56.56 0 0 0 0 .796L1.29 3.211a.555.555 0 0 0 .613.122.5.5 0 0 0 .183-.122l2.25-2.25A.563.563 0 1 0 3.54.165m0 4.5L1.688 6.518.961 5.79a.566.566 0 0 0-.796 0 .56.56 0 0 0 0 .796L1.29 7.711a.555.555 0 0 0 .613.122.5.5 0 0 0 .183-.122l2.25-2.25a.563.563 0 1 0-.796-.796m0 4.5-1.852 1.853-.727-.728a.564.564 0 0 0-.796.796l1.125 1.125a.555.555 0 0 0 .613.122.5.5 0 0 0 .183-.122l2.25-2.25a.563.563 0 1 0-.796-.796"
    }, null, -1)
  ])))
}
export default { render: render }